import { useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import api, { formatApiErrorDetail } from "@/lib/apiClient";
import { Monogram } from "@/components/Logo";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password reset. Please sign in.");
      navigate("/login");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-background">
      <div className="w-full max-w-sm">
        <div className="flex justify-center mb-8">
          <Monogram size={52} />
        </div>
        <h1 className="font-brand font-light text-3xl tracking-tight mb-8 text-center">Choose a new password</h1>
        {!token ? (
          <p className="text-center text-sm text-destructive">Invalid reset link.</p>
        ) : (
          <form onSubmit={submit} className="space-y-5">
            <div className="space-y-2">
              <Label htmlFor="password">New password</Label>
              <Input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                minLength={6}
                required
                data-testid="reset-password-input"
              />
            </div>
            {error && <div className="text-sm text-destructive" data-testid="reset-error">{error}</div>}
            <Button type="submit" className="w-full rounded-full h-11" disabled={loading} data-testid="reset-submit-button">
              {loading ? "Saving…" : "Reset password"}
            </Button>
            <Link to="/login" className="block text-center text-sm text-muted-foreground hover:text-foreground">
              Back to sign in
            </Link>
          </form>
        )}
      </div>
    </div>
  );
}
